import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import {
  Card,
} from '../../../../../components/Lists';
import OpacityAnimation from '../../../../../components/OpacityAnimation';
import { BranchType } from '../../types';

interface ListInterface {
  filteredBranches: BranchType[];
}

export default function List({
  filteredBranches,
}: ListInterface) {
  return (
    <Container>
      <Row xs={1} md={1} lg={2}>
        {filteredBranches?.map((branch) => (
          <Col key={`${branch.fantasyName}${branch.cnpj}${branch.employeesQty}`}>
            <OpacityAnimation>
              <Card>
                <div className="info">
                  <div className="card-title">
                    <strong>{branch.fantasyName}</strong>
                    <small>{branch.kind}</small>
                  </div>
                  <span>
                    CNPJ:
                    {' '}
                    {branch.cnpj}
                  </span>
                  <span>
                    {branch.employeesQty}
                    {' '}
                    funcionários
                  </span>
                </div>
              </Card>
            </OpacityAnimation>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
